import { render, staticRenderFns } from "./AccordionPanel.vue?vue&type=template&id=1434f137&"
import script from "./AccordionPanel.vue?vue&type=script&lang=js&"
export * from "./AccordionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports